import { makeApiClientTag } from 'effect-tanstack-start/client';
import { ApiHttpApiContract } from './api-contract';

export const ApiClient = makeApiClientTag(ApiHttpApiContract);
